module.exports = __webpack_public_path__ + "static/pic4-93fa8ecb41e8f0d305c1046f66c7af3f.png";